import styled from "styled-components";
import { COLOURS } from "../../variables/Colors";
import { setFlex, setPosition } from "../../variables/Position";

export const LoadingWrapper = styled.div`
  ${setPosition({ position: "absolute", top: "0", left: "0", zIndex: "9999" })};
  background-color: ${COLOURS.primary.black};
  height: 100%;
  width: 100%;
  display: none;
  &.active {
    display: block;
  }
`;

export const Container = styled.div`
  ${setPosition({ position: "fixed", top: "0", left: "0", zIndex: 9999 })};
  height: 100vh;
  width: 100%;
  &.remove {
    display: none;
  }
`;

export const ItemContainer = styled.div`
  margin-bottom: 10px;
  ${setPosition({ position: "relative" })};
  ${props => props.$fade && "opacity: 0"};
`;

export const LoadingContainer = styled.div`
  ${setFlex({ justify: "center", align: "center", direction: "column" })};
  height: 100%;
`;

export const Headline = styled.h4`
  font-family: "overpass-lotus-headlines";
  font-size: ${props => (props.$small ? "0.8rem" : "1rem")};
  line-height: ${props => (props.$small ? "0.8rem" : "1rem")};
  text-transform: uppercase;
  color: ${COLOURS.primary.yellow};
  text-align: left;
  ${props =>
    props.$underline &&
    `text-decoration: underline;
  text-underline-offset: 5px`};
`;
